import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-ktostamm-lieferant-detail-view',
  imports: [],
  templateUrl: './ktostamm-lieferant.detail-view.html',
  styleUrls: ['./ktostamm-lieferant.detail-view.css'],
})
export class KtostammLieferantDetailView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
